// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeLeagueConferenceListBody = {
  leagueId: string;
};

export type typeLeagueConferenceListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    leagueId: string;
    conferences: { conferenceKey: string; label: string }[];
  };
};

export type typeLeagueConferenceListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeLeagueConferenceListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeLeagueConferenceListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaLeagueConferenceListBody = {
  type: "object",
  properties: { leagueId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["leagueId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createLeagueConferenceList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaLeagueConferenceListBody);
  }

  return async function postLeagueConferenceList(
    payload: typeLeagueConferenceListBody,
  ): Promise<
    typeLeagueConferenceListOutput200 | typeLeagueConferenceListOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postLeagueConferenceList" failed before calling the network. #22b0db66e843`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#22b0db66e843" },
        },
        data: null,
      } as typeLeagueConferenceListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/league/conference-list`,
      httpMethod: "POST",
      options,
    })) as
      typeLeagueConferenceListOutput200 | typeLeagueConferenceListOutput400;
  };
}
